import { render } from "./IncludeForm.vue?vue&type=template&id=5f584f60"
import script from "./IncludeForm.vue?vue&type=script&lang=js"
export * from "./IncludeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__